import React from 'react';

import styled from '@emotion/styled';

import RichTextDisplay from '../../../../components/RichTextDisplay/RichTextDisplay';

interface ISummaryBody {
  jobDescription?: string;
}

const SummaryBody: React.FC<ISummaryBody> = ({ jobDescription }) => {
  return (
    <Container>
      <RichTextDisplay
        richTextContent={
          jobDescription
            ? jobDescription
            : 'This is where the Job Description should be displayed'
        }
      />
    </Container>
  );
};

export default SummaryBody;

const Container = styled.div`
  width: 100%;
`;
